import styled from '@emotion/styled';

export const FullScreenLoaderComponent = styled.div`
  position: fixed;
  top: 0;
  width: 100%;
  height: 100%;
  // background: hsla(328, 100%, 0%, 0.6);
  background: white;
  z-index: 50;
  text-align: center;
`;

export const LoaderContent = styled.div`
  margin: 240px auto;
  max-width: 300px;

  @media screen and (max-height: 560px) {
    margin: 80px auto;
  }
`;
export const BodyText = styled.p``;

export const CustomSpacingDivComponent = styled.div`
  padding: 0px 0px 30px 0px;
`;
